<form
  class="p-grid p-dir-col mu-position-relative mu-form-content"
  [formGroup]="formData"
  appValidator
  id="mu-auth-account-data-form"
  *ngIf="formData"
>
  <div class="p-grid container-form mu-full-width">
    <app-mu-form-fieldset [customGridCol]="3" class="mu-auth-account-type">
      <p-radioButton
        class="mu-radio-button"
        value="1"
        name="accountType"
        formControlName="accountType"
        [label]="'form.label.person' | translate"
      ></p-radioButton>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="3" class="mu-auth-account-type">
      <p-radioButton
        class="mu-radio-button"
        value="2"
        name="accountType"
        formControlName="accountType"
        [label]="'form.label.company' | translate"
      ></p-radioButton>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset label="email" [customGridCol]="12" [iconFeedback]="true">
      <input
        type="email"
        name="email"
        id="email"
        formControlName="email"
        autocomplete="off"
        [placeholder]="'form.placeholder.email' | translate"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset label="password" [customGridCol]="12">
      <app-mu-form-password
        field="password"
        [passwordCheckerName]="passwordCheckerName"
        [passwordCheckerField]="passwordCheckerField"
        [passwordCheckerParams]="passwordCheckerParams"
        [formGroup]="formData"
        [checkPassword]="true"
      ></app-mu-form-password>
    </app-mu-form-fieldset>
  </div>
  <app-mu-form-buttons [customGridCol]="12" [alwaysFullWidth]="true">
    <p-button
      muButtonRight
      [label]="'form.button.next' | translate"
      [disabled]="formData.get('isInvalidForm').value"
      class="mu-button mu-button-full-width"
      type="button"
      (click)="saveStep()"
    >
      <app-loading [showLoading]="loader" type="icon"></app-loading>
    </p-button>
  </app-mu-form-buttons>
  <div class="p-grid container-form">
    <app-mu-form-fieldset label="" [customGridCol]="12" customClass="mu-form-checkbox" [hideError]="true">
      <p-checkbox id="terms" name="terms" formControlName="terms" binary="true"></p-checkbox>
      <div class="mu-terms" [innerHTML]="'context.accountData.terms' | translate: { terms: termsLink, politics: politicsLink }"></div>
    </app-mu-form-fieldset>
  </div>
</form>
